export default __webpack_public_path__ + "8de32b58e1a080bb67c09888bb8d80f3.png";